module.exports = __webpack_public_path__ + "img/cases-brand-vive-8.ec97eb84.jpg";